import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconBookmarkFill';
/** Renders an SVG icon. */
const SvgBookmarkFill = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M24 9a3 3 0 0 0-3-3H11a3 3 0 0 0-3 3v17.028c0 1.182 1.294 1.885 2.277 1.284L16 23.227l5.723 4.083c.983.602 2.277-.1 2.277-1.283z"
      />
    </svg>
  );
};
SvgBookmarkFill.displayName = displayName;
export default SvgBookmarkFill;
